<template>
  <div class="content">
    <div class="hour-forecast">
      <div class="publish-time" v-if="slideLiveResult.time">
        <!--        <i class="el-icon-time"></i>-->
        <!--        数据时间：{{ $moment(slideLiveResult.time[slideLiveResult.time.length - 1]).format('YYYY-MM-DD HH:mm') }}-->
        <div>
          {{
            $moment(
              slideLiveResult.time[slideLiveResult.time.length - 1],
            ).format("YYYY-MM-DD HH:mm")
          }}更新
        </div>
      </div>
      <div class="hour-forecast-wrap">
        <div class="hour-forecast-list" ref="hourForecastList">
          <div
            :id="cardEchart ? 'card-live-forest-chart' : 'live-forest-chart'"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import echarts from "@/config/echarts/index.js";
import {
  getHourForecastOption,
  getDaysForecastOption,
} from "@/config/echarts/option/live-forest.js";
import { apiData } from "@/api/index";
import { mapMutations, mapState } from "vuex";
export default {
  props: ["params", "forecastType", "cardEchart"],
  data() {
    return {
      charts: "",
      giftData: {},
      timmer: null,
    };
  },
  watch: {
    activeCountyId: {
      handler() {
        setTimeout(() => {
          this.$nextTick(() => {
            this.getGiftData();
          });
        }, 100);
      },
      immediate: true,
    },
    forecastType() {
      this.resetEchart();
    },
    giftDataResult: {
      handler() {
        this.$nextTick(() => {
          this.getGiftData();
        });
      },
      deep: true,
    },
  },
  computed: {
    ...mapState("home", [
      "objsList",
      "activeCountyId",
      "giftDataResult",
      "slideLiveResult",
    ]),
  },
  methods: {
    initEchart() {
      // 24小时预报温度曲线图
      const idName = this.cardEchart
        ? "card-live-forest-chart"
        : "live-forest-chart";
      const tempChart = echarts.init(document.getElementById(idName));
      tempChart.setOption(getHourForecastOption());
      this.charts = tempChart;

      // 页面缩放
      window.onresize = () => {
        Vue.prototype.$rootFontSize = (document.body.clientWidth / 1920) * 16;
        document.getElementsByTagName("html")[0].style.fontSize =
          this.$rootFontSize + "px";
        this.charts.resize();
      };

      this.$bus.$on("changeLiveForestResize", () => {
        this.$nextTick(() => {
          this.charts.resize();
        });
      });

      this.$bus.$on("changeCardData", () => {
        this.$nextTick(() => {
          this.charts.resize();
        });
      });
    },
    // 获取gif预报
    async getGiftData() {
      // const index = this.objsList.findIndex(item => item.id === this.activeCountyId)
      const slideliveResult = this.slideLiveResult;
      if (!this.charts) {
        this.initEchart();
      }
      if (!this.giftDataResult.datedec) {
        return "";
      }
      const result = this.giftDataResult;
      this.giftData = result;
      const ptimestemp = result.ptimestemp;
      const time = this.$moment(result.ptimestemp).format("HH");
      const hour = new Date().getHours();

      if (
        (time === "08" && hour >= 8 && hour < 20) ||
        (time === "20" && (hour < 8 || hour >= 20))
      ) {
        this.giftData.icon = this.giftData.icons_f;
        this.giftData.desc = this.giftData.desc_f;
      } else if (
        (time === "08" && (hour < 8 || hour >= 20)) ||
        (time === "20" && hour >= 8 && hour < 20)
      ) {
        this.giftData.icon = this.giftData.icons_l;
        this.giftData.desc = this.giftData.desc_l;
      }

      // 格式化滑动数据

      const nowTime = new Date().getTime();
      const timAarr = [];
      let startTime = Date.now();

      let start = nowTime - time;
      const hourTime = 1000 * 60 * 60;
      if (
        (time === "08" && nowTime <= ptimestemp) ||
        (time === "20" && nowTime <= ptimestemp)
      ) {
        start = 0;
        startTime = ptimestemp;
      } else if ((time === "08" || time === "20") && nowTime > ptimestemp) {
        const diff = Math.floor((nowTime - ptimestemp) / hourTime);
        start = diff;
        startTime = ptimestemp + diff * 3600000;
      }
      console.log("startTime", startTime);
      for (let i = 0; i < 24; i++) {
        // const step = i * 2 + 1
        const value = startTime + 3600000 * i;
        // const time = this.$moment(value).format('HH:00')
        timAarr.push(value);
      }

      const temp = this.giftData.gift_t.slice(start, start + 24);
      const hourrf = this.giftData.gift_rain.slice(start, start + 24);

      const excludes = [null, "null"];
      const temp1 = [...slideliveResult.t, ...temp].map((item) =>
        excludes.includes(item) ? "--" : item,
      );
      const hourrf1 = [...slideliveResult.hourrf, ...hourrf].map((item) =>
        excludes.includes(item) ? "--" : item,
      );
      const time1 = [...slideliveResult.time, ...timAarr];

      // temp1 = temp1.map((item, index) => {
      //   if (index % 4 === 0) {
      //     return item
      //   }
      // })
      // hourrf1 = hourrf1.filter((item, index) => {
      //   if (index % 4 === 0) {
      //     return true
      //   }
      // })
      // time1 = time1.filter((item, index) => {
      //   if (index % 4 === 0) {
      //     return true
      //   }
      // })

      const option1 = getHourForecastOption();
      const hourForecastWidth = 27.9;
      const hourForecastList = this.$refs.hourForecastList;
      hourForecastList.style.width = hourForecastWidth * timAarr.length + "px";
      option1.xAxis.data = time1;
      const num = time1.length - 24;
      const a2 = [];
      for (let index = 0; index < num - 1; index++) {
        a2.push("--");
      }
      const a = [
        "--",
        "--",
        "--",
        "--",
        "--",
        "--",
        "--",
        "--",
        "--",
        "--",
        "--",
        "--",
        "--",
        "--",
        "--",
        "--",
        "--",
        "--",
        "--",
        "--",
        "--",
        "--",
      ];
      option1.series[0].data = [...temp1.slice(0, num), ...a];
      option1.series[1].data = [...hourrf1.slice(0, num), ...a];
      option1.series[2].data = [...a2, ...temp1.slice(num - 1)];
      option1.series[3].data = [...a2, ...hourrf1.slice(num - 1)];
      option1.yAxis[0].max = Math.floor(Math.max(...temp1) + 2);
      option1.yAxis[0].min = Math.floor(Math.min(...temp1) - 2);
      option1.yAxis[0].min = option1.yAxis[0].min - 2;
      option1.yAxis[1].max = Math.floor(Math.max(...hourrf1) + 1);
      if (option1.yAxis[1].max < 5) {
        option1.yAxis[1].max = 5.0;
      }
      option1.yAxis[1].min = Math.floor(Math.min(...hourrf1));
      this.charts.clear();
      this.charts.setOption(option1);
      this.$nextTick(() => {
        this.charts.resize();
      });
    },

    resetEchart() {
      this.$nextTick(() => {
        this.charts && this.charts.resize();
      });
    },
  },
};
</script>

<style lang="less" scoped>
.content {
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  padding: 2.6vw 1.04vw 0.56vw;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  border-radius: 0.63vw;
  // pointer-events: none;

  .hour-forecast {
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    padding: 0vw;

    .hour-forecast-wrap {
      position: relative;
      // top: -2.04vw;
      width: 100%;
      margin-top: 0.52vw;
      height: calc(100% - 0.52vw);
      overflow: hidden;

      .hour-forecast-list {
        width: 100% !important;
        display: flex;
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        transition: all 0.3s linear;

        .item {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          align-items: center;
          width: 5.58rem;

          span {
            font-size: 0.75rem;
            color: #fff;
          }

          .des {
            font-size: 0.88rem;
            color: #fff;
          }

          img {
            width: 2.25rem;
          }

          .chart {
            height: 90%;
          }

          .wind {
            color: #fff;
          }
        }

        #live-forest-chart,
        #card-live-forest-chart {
          position: absolute;
          left: 0;
          top: 0;
          height: 100%;
          width: 100%;
        }
      }
    }

    .left-botton {
      width: 0.81rem;
      height: 1.88rem;
      background: url("../../../assets/images/左.png") no-repeat;
      background-size: contain;
      position: absolute;
      top: 50%;
      margin-top: -0.94rem;
      left: 1.2rem;
      cursor: pointer;
    }

    .right-botton {
      width: 0.81rem;
      height: 1.88rem;
      background: url("../../../assets/images/右.png") no-repeat;
      background-size: contain;
      position: absolute;
      top: 50%;
      margin-top: -0.94rem;
      right: 1.2rem;
      cursor: pointer;
    }
  }

  .days-forecast {
    height: 100%;
    // padding: 8% 3% 0 2%;
    box-sizing: border-box;

    .days-forecast-list {
      display: flex;
      justify-content: space-between;
      height: 100%;
      position: relative;

      .item {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        width: 6.85rem;

        span {
          font-size: 0.75rem;
          color: #fff;
        }

        font {
          font-size: 0.88rem;
          color: #fff;
        }

        img {
          width: 2rem;
        }

        .chart {
          height: 50%;
        }
      }

      #high-low-temp-chart {
        position: absolute;
        left: 2.3rem;
        right: 2.3rem;
        top: 52%;
        height: 45%;
      }
    }
  }

  .publish-time {
    display: flex;
    align-items: center;
    position: absolute;
    right: 2.08vw;
    top: 0.8vw;
    color: #fff;
    font-size: 0.63vw;

    .el-icon-time {
      margin-right: 0.26vw;
    }
  }
}
</style>
